<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()" autocomplete="off">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.last-name' |translate}}</mat-label>
      <input matInput type="text" [formControl]="nameControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.first-name' |translate}}</mat-label>
      <input matInput type="text" [formControl]="firstNameControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.weee-system.weee-system' |translate}}</mat-label>
      <mat-select [formControl]="weeeSystemControl">
        <mat-option value="">-</mat-option>
        <mat-option *ngFor="let ws of weeeSystems" [value]="ws.id">{{ws.description}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.weee-system.role' |translate}}</mat-label>
      <mat-select [formControl]="roleControl">
        <mat-option value="">-</mat-option>
        <mat-option *ngFor="let role of roles" [value]="role.id">{{role.name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.status' |translate}}</mat-label>
      <mat-select [formControl]="statusControl">
        <mat-option value="">-</mat-option>
        <mat-option [value]="2">Active</mat-option>
        <mat-option [value]="1">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
  </form>
</div>
